import { element } from 'protractor';
import { ReportPerformService } from '../../services/report-perform.service';
import { Apply } from '../../models/apply';
import { Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { MdDialog, MdSelectChange } from '@angular/material';
import { JobsOffer } from '../../models/jobs-offer';
import { ConfigurationService } from '../../services/configuration.service';
import { Constants } from '../constants';

@Component({
  selector: 'app-job-report-c',
  templateUrl: './job-report-contract.component.html',
  styleUrls: ['./job-report-contract.component.css']
})

export class JobReportContractComponent implements OnChanges, OnInit{
  job: JobsOffer;
  create: boolean;
  role: string;
  email: string;
  applicants: Apply;
  @Input() nameComponent;
  errorMessage: string;
  reportDescription: string = null;
  loading: boolean = false;
  public STATUS = Constants;
  public step: number;
  public filled: boolean;
  public users: any;
  perform: any;
  perform_date: string;
  report_data: any;
  report_users: any;
  bool_answer = false;
  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  constructor(public dialog: MdDialog,
              public dialogRef: MdDialogRef<JobReportContractComponent>,
              private configurationService: ConfigurationService,
              private reportPerformService: ReportPerformService,
              @Inject(MD_DIALOG_DATA) public data: any,
              ) {
  }

  ngOnInit () {
    this.job = this.data.job;
    this.create = this.data.create;
    this.users = this.data.users;
    this.perform = this.data.perform;
    this.perform_date = this.data.perform_date;
    this.report_data = this.data.report_data;
    this.report_users = this.data.report_users;


    this.users.forEach(v => {
      if (v.answers == [] ||  v.answers_company == []) {
        this.bool_answer = true;
      }
    });

    console.log(this.users);
    console.log(this.bool_answer);

    this.configurationService.configuration$.subscribe(
      response => {
        if (response) {
          this.role = localStorage.getItem('role');
        }
      }
    );
    if (!this.create) {
      this.reportDescription = this.report_data.moreinfo;
      this.users.forEach(element => {
        this.report_users.forEach(element2 => {
        if (element.user_rid === element2.user_id) {
          element.description = element2.moreinfo;
          }
        });
      });
    } else {
      this.users.forEach((element, i) => {
          this.users[i].description = '';
      });
    }




    // this.jobService.getOffersApplicantByOfferReport(this.job.id, 1).subscribe(
    //   data => {
    //     let applicantss:any = data.applicants;
    //     let list = [];
    //     if (this.create){
    //       applicantss.forEach(element => {
    //         element.firstname = element.user.firstname;
    //         element.lastname = element.user.lastname;
    //         element.photo = element.user.photo;
    //         element.user_id = element.user.id;
    //         element.email = element.user.email;
    //         element.description = '';

    //         let total;
    //         let competenceValues = [];
    //         element.competences.forEach(elementC => {
    //           total = 0;
    //           if (elementC.answer) {
    //             elementC.answer.forEach(elementA => {
    //               total = total + elementA.option.percentage;
    //             });
    //             this.filled = true;
    //           } else {
    //             this.filled = false;
    //           }
    //           total = Math.trunc(total / 3);
    //           const value = total + '%';
    //           competenceValues.push({name: elementC.title, value: value});
    //         });

    //         element.competence = competenceValues;
    //         list.push(element);

    //       });
    //     }else {
    //       this.reportDescription = this.report_data.moreinfo;
    //       applicantss.forEach(element => {
    //         let desc = '';
    //         console.log(element);
    //         this.report_users.forEach(element2 => {
    //           if (element.user.id === element2.user_id) {
    //             desc = element2.moreinfo;
    //           }
    //         });
    //         element.firstname = element.user.firstname;
    //         element.lastname = element.user.lastname;
    //         element.photo = element.user.photo;
    //         element.user_id = element.user.id;
    //         element.email = element.user.email;
    //         element.description = desc;

    //         let total;
    //         let competenceValues = [];
    //         element.competences.forEach(elementC => {
    //           total = 0;
    //           if (elementC.answer) {
    //             elementC.answer.forEach(elementA => {
    //               total = total + elementA.option.percentage;
    //             });
    //             this.filled = true;
    //           } else {
    //             this.filled = false;
    //           }
    //           total = Math.trunc(total / 3);
    //           const value = total + '%';
    //           competenceValues.push({name: elementC.title, value: value});
    //         });

    //         element.competence = competenceValues;

    //         list.push(element);
    //       });
    //     }

    //     this.applicants = list;
    //     this.loading = false;
    //   },
    //   error => {
    //     this.errorMessage = <any>error;
    //     this.loading = false;
    //   }
    // );
  }



    validEmail () {
      if (this.email != undefined && this.email != '') {
        let a = this.emailRegex.test(this.email);
        return a;
      }
      return true;
    }



  onReport(){
    if(this.create){
      this.onPostReport();
    }else{
      this.onPutReport();
    }
  }

  onPostReport() {
    this.reportPerformService.postReportPerform(this.perform.id, this.reportDescription, this.users, this.perform_date, this.email).subscribe(
      data => {

        this.dialogRef.close('yes');
      },
      error => {
        this.errorMessage = <any>error;
        this.loading = false;
      }
    );
  }

  onPutReport() {
    this.reportPerformService.putReportPerform(this.perform.id, this.reportDescription, this.applicants, this.perform_date, this.email).subscribe(
      data => {

        this.dialogRef.close('yes');
      },
      error => {
        this.errorMessage = <any>error;
        this.loading = false;
      }
    );
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  getPercentage(competence) {
    let competence_apply_id = '';
    let total = 0;
    let value = [];
    let i = competence.length;
    competence.forEach(elementCompetence => {
      elementCompetence.answers.forEach(elementAnswer => {
        if (competence_apply_id == '') {
          competence_apply_id = elementCompetence.competence_apply_id;
        }
        if (competence_apply_id != elementCompetence.competence_apply_id) {
          value.push ({name: competence_apply_id, value: total});
          competence_apply_id = elementCompetence.competence_apply_id;
          total = 0;
        }
        total = total + elementAnswer.option.percentage;
      });
      i--;
    });
    if (i > 0) {
      value.push ({name: competence_apply_id, value: total});
    }
    console.log(value);
    return (value);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/job-report-contract/job-report-contract.component.ts